import React from 'react';
import { observer } from "mobx-react-lite";
import { SettingsPageView } from '../../Pages/SettingsPageView';
import { RecordingsView } from './RecordingsView';
import { MyDataGoWhereEventArchiveFormat } from '../../State/EvidenceDB/DatabaseTypes';
import { importRecordingAndDbEventsFromArchive, importRecordingFromJsonStream } from '../../State/EvidenceDB/SaveRecording';
import { SerializableError } from "../../lib/utils/SerializedException";
import { WindowRoutingState, WindowRoutingStateContext } from "./WindowRoutingState";
import { ProcessInfo } from "../../State/ProcessInfo";
import { PrivacyPolicy } from "../../Pages/public/PrivacyPolicy";
import { GlobalContext } from './GlobalContext';
import { LicensePageView } from '../../Pages/LicensePageView';
import { ExtensionName } from '../../constants';
import { RecordingPanelView } from './RecordingPanelView';
import { NavigationHeaderView } from './NavigationHeaderView';
import { HomePageView } from '../../Pages/HomePageView';
import { JSONParser } from "@streamparser/json-whatwg";

const listenForDroppedFiles = (windowRoutingState: WindowRoutingState) => {
	const domNode = document.getElementById('root')!;
	// File drop
	domNode.addEventListener('dragover', (event) => {
		event.preventDefault();
		const {dataTransfer} = event;
		if (dataTransfer == null) return;
		// Without this, the drop event won't fire.
		event.preventDefault();
	});


	domNode.addEventListener('drop', async (event) => {
		event.preventDefault();
		const {dataTransfer} = event;
		if (dataTransfer == null) return;
		const {files} = dataTransfer;
		for (const file of files) {
			//const json = await file.text();
			// ProcessInfo.log(`Read json file of size ${json.length} starting ${json.slice(0, 24)} and ending ${json.slice(-24)}`);
			try {
				const readableStream: ReadableStream<Uint8Array> = file.stream();
				await importRecordingFromJsonStream(readableStream, (percent) => {});
				// 	ProcessInfo.log("Parsed archive", archive);
				// if (archive != null && typeof archive === 'object' && "events" in archive && Array.isArray(archive.events)) {
				// 	ProcessInfo.log("Importing archive", archive);
				// 	await importRecordingAndDbEventsFromArchive(archive, windowRoutingState.setUploadInProgressPercentage).then(
				// 		(_percentDone) => {}
				// 	);		
				// }
			} catch (e) {
				console.error("Error importing recording from dropped file", e);
				alert(`Failed to import ${SerializableError.from(e, "Archive JSON Parser").serialize().message}`);
			} finally {
				windowRoutingState.setUploadInProgressPercentage(undefined);
			}
		}
	});
}

export const PageRouter = observer( () => {
	const windowRoutingState = React.useContext(WindowRoutingStateContext);
	if (windowRoutingState == null) return null;
	const {recordingPanelState, uploadInProgressPercentage} = windowRoutingState;
	if (uploadInProgressPercentage != null) {
		document.title = `Importing into ${ExtensionName}`;
		return (<div>Importing {uploadInProgressPercentage}% complete</div>);
	} else if (recordingPanelState != null) {
		document.title = `${recordingPanelState.dbRecordingEntryWriter?.nameOrDescription} - ${ExtensionName}`;
		return (<RecordingPanelView {...{recordingPanelState}} />);
	}
	switch (windowRoutingState.page) {
		case 'settings':
			document.title = `Settings - ${ExtensionName}`;
			return (<SettingsPageView />);
		case 'license':
			 document.title = `Licensing - ${ExtensionName}`;
			return (<LicensePageView />);
		case 'privacy':
			document.title = `Privacy Policy - ${ExtensionName}`;
			return (<PrivacyPolicy />);
		case 'recordings':
			document.title = `Recordings - ${ExtensionName}`;
			return (<RecordingsView />);
		default:
			document.title = ExtensionName;
			return (<HomePageView />);
	}
});

export const AppWindow = observer( (
	{globalContext, windowRoutingState}
	: {
	globalContext: GlobalContext;
	windowRoutingState: WindowRoutingState;
}) => {
	listenForDroppedFiles(windowRoutingState);
	return (
		<WindowRoutingStateContext.Provider value={windowRoutingState}>
		<GlobalContext.Provider value={globalContext}>
			<NavigationHeaderView />
			<PageRouter />
		</GlobalContext.Provider>
		</WindowRoutingStateContext.Provider>
	)
});
